<template>
  <div id="app">
    <div id="sakura" style="position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; z-index: 9999; pointer-events: none;"></div>

    <router-view></router-view>

    <!-- 折叠控制按钮 - 去掉 tooltip -->
    <div class="widget-toggle-btn" @click="isWidgetsCollapsed = !isWidgetsCollapsed">
      <span class="toggle-icon" :class="{ 'is-collapsed': isWidgetsCollapsed }">👆</span>
    </div>

    <!-- 全局组件 - 去掉所有 tooltip -->
    <transition-group name="widget-fade" tag="div" class="global-widgets-wrapper">
      <div v-show="!isWidgetsCollapsed" key="share" class="widget-item">
        <ShareButton />
      </div>

      <div v-show="!isWidgetsCollapsed" key="tips" class="widget-item">
        <Tips :analysis="analysis" :sakura-enabled="sakuraEnabled" @toggle-sakura="toggleSakura" />
      </div>

      <div v-show="!isWidgetsCollapsed" key="music" class="widget-item">
        <MusicPlayer />
      </div>

      <div v-show="!isWidgetsCollapsed" key="search" class="widget-item">
        <SearchBingBtu @upTypeRow="upTypeRow" />
      </div>
    </transition-group>

    <el-backtop style="background-color: transparent; z-index: 9999" :right="6" :visibility-height="50">
      <div class="back-top-btn">
        <span class="top-icon">⇪</span>
      </div>
    </el-backtop>
  </div>
</template>

<script>
import HelloWorld from '@/components/HelloWorld.vue';
import SideBar from '@/components/menu/SideBar.vue';
import MusicPlayer from '@/components/tip/MusicPlayer.vue';
import SearchBingBtu from '@/components/tip/SearchBingBtu.vue';
import router from '@/router';
import { getCount } from '@/api/analysis';
import Tips from '@/components/tip/Tips.vue';
import ShareButton from '@/components/tip/ShareButton.vue';

export default {
  name: 'App',
  components: {
    HelloWorld,
    SideBar,
    MusicPlayer,
    SearchBingBtu,
    Tips,
    ShareButton,
  },
  data() {
    return {
    analysis: {
      danmaku: '0',
      life: '0',
      museum: '0',
      visit: '0'
    },
    sakuraEnabled: false,
    sakuraAnimation: null,
    sakuraResizeHandler: null,
    isWidgetsCollapsed: false
  }
  },
  created() {
  window.sysConfig = this.$store.state.sysConfig
},
  mounted() {
    this.disableF12();
    this.$store.dispatch('getSysConfig')
    this.getCountInfo();
    this.initSakura();
  },
  methods: {
    async getCountInfo() {
      const resp = await getCount({});
      if (resp.code == 200 && resp.data != null) {
        this.analysis = resp.data;
      }
    },
    upTypeRow() {
      router.push("/").catch(() => { });
    },
    disableF12() {
      document.addEventListener('keydown', this.handleKeyDown)
    },
    handleKeyDown(event) {
      if (event.key === 'F12' || event.keyCode === 123) {
        event.preventDefault()
        return false
      }
      if (event.ctrlKey && event.shiftKey && event.key === 'I') {
        event.preventDefault()
        return false
      }
      if (event.ctrlKey && event.shiftKey && event.key === 'J') {
        event.preventDefault()
        return false
      }
      if (event.ctrlKey && event.key === 'u') {
        event.preventDefault()
        return false
      }
    },

    toggleSakura() {
      this.sakuraEnabled = !this.sakuraEnabled;
      if (this.sakuraEnabled) {
        this.initSakura();
      } else {
        this.stopSakura();
      }
    },

    stopSakura() {
      if (this.sakuraAnimation) {
        cancelAnimationFrame(this.sakuraAnimation);
        this.sakuraAnimation = null;
      }
      const container = document.getElementById('sakura');
      if (container) {
        container.innerHTML = '';
      }
      if (this.sakuraResizeHandler) {
        window.removeEventListener('resize', this.sakuraResizeHandler);
      }
    },

initSakura() {
  if (!this.sakuraEnabled) return;
  this.stopSakura();
  const container = document.getElementById('sakura');
  if (!container) return;

  const canvas = document.createElement('canvas');
  container.appendChild(canvas);
  const ctx = canvas.getContext('2d');
  let W = window.innerWidth;
  let H = window.innerHeight;
  canvas.width = W;
  canvas.height = H;

  const particleCount = 55;
  const particles = [];

  // 花瓣图片
  const petalImg = new Image();
  // 这里自行替换花瓣图片地址 / base64
  petalImg.src = "data:image/png;base64,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";
  
  class Particle {
    constructor() {
      this.x = Math.random() * W;
      this.y = Math.random() * -H;
      this.r = Math.random() * 8 + 4;
      this.speed = Math.random() * 0.6 + 0.8;
      this.wind = Math.random() * 0.4 - 0.2;
      this.angle = Math.random() * 360;
      this.angleSpeed = Math.random() * 0.4 - 0.2;
    }

    // 绘制图片花瓣
    draw() {
      if (!petalImg.complete) return;
      ctx.save();
      ctx.translate(this.x, this.y);
      ctx.rotate((this.angle * Math.PI) / 180);
      // 以r为缩放尺寸绘制图片
      ctx.drawImage(
        petalImg,
        -this.r,
        -this.r,
        this.r * 2,
        this.r * 2
      );
      ctx.restore();
    }

    update() {
      this.y += this.speed;
      this.x += this.wind;
      this.angle += this.angleSpeed;
      // 飘出底部重新回到顶部
      if (this.y > H + this.r) {
        this.y = -this.r;
        this.x = Math.random() * W;
      }
    }
  }

  // 等待图片加载完成再生成粒子开始渲染
  petalImg.onload = () => {
    for (let i = 0; i < particleCount; i++) {
      particles.push(new Particle());
    }
    const renderLoop = () => {
      if (!this.sakuraEnabled) return;
      ctx.clearRect(0, 0, W, H);
      particles.forEach(petal => {
        petal.update();
        petal.draw();
      });
      this.sakuraAnimation = requestAnimationFrame(renderLoop);
    };
    renderLoop();
  };

  // 窗口大小适配
  this.sakuraResizeHandler = () => {
    W = window.innerWidth;
    H = window.innerHeight;
    canvas.width = W;
    canvas.height = H;
  };
  window.addEventListener('resize', this.sakuraResizeHandler);
}
  },

  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeyDown);
    this.stopSakura();
  }
}
</script>

<style>
/* 全局样式重置 */
html,
body {
  margin: 0;
  width: 100%;
  height: 100%;
}
/* 在 #app 样式后添加 */
#app {
  width: 100%;
  min-height: 100vh;
  position: relative;
  z-index: 0;
  overflow-x: hidden;

  background: url("@/assets/back/back-01.jpg");
  
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;

  -webkit-tap-highlight-color: transparent;
  text-shadow: 0 0 1px rgba(0, 0, 0, 0.05);
  font-family: 'LXGW WenKai', sans-serif !important;
}

/* ✅ 添加暗色遮罩层 */
#app::before {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.2); /* 调整透明度控制暗度 */
  z-index: 0;
  pointer-events: none; /* 让点击穿透 */
}

.global-widgets-wrapper {
  position: fixed;
  right: 6px;
  bottom: 80px;
  z-index: 9998;
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  gap: 10px;
}

.widget-item {
  display: flex;
  justify-content: center;
}

.widget-toggle-btn {
  position: fixed;
  right: 6px;
  bottom: 336px;
  width: 50px;
  height: 50px;
  -webkit-backdrop-filter: blur(10px);
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.4);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 9999;
  transition: all 0.3s ease;
}

.widget-toggle-btn:hover {
  transform: scale(1.15);
  box-shadow: 0 0 12px rgba(255, 180, 180, 0.3);
}

.toggle-icon {
  font-size: 22px;
  color: #fff;
  transition: transform 0.3s ease;
}

.widget-fade-enter-active,
.widget-fade-leave-active {
  transition: all 0.35s cubic-bezier(0.22, 0.61, 0.36, 1);
}

.widget-fade-enter,
.widget-fade-leave-to {
  opacity: 0;
  transform: translateX(30px) scale(0.8);
}

@media only screen and (min-width: 768px) {
  .markdown-body img {
    max-width: 100% !important;
    max-height: 500px !important;
    height: auto !important;
    object-fit: contain !important;
    background-color: rgba(255, 255, 255, 0) !important;
    display: block !important;
    margin: 0 auto !important;
  }

  .auto-textarea-wrapper,
  .auto-textarea-input,
  .markdown-body {
    color: var(--font-color-1) !important;
    font-family: 'LXGW WenKai', sans-serif !important;
  }

  html,
  body {
    cursor: default;
  }
}

@media only screen and (max-width: 768px) {
  .auto-textarea-wrapper,
  .auto-textarea-input,
  .markdown-body {
    color: var(--font-color-1) !important;
    font-family: 'LXGW WenKai', sans-serif !important;
  }
}

.el-backtop{
  width: 50px !important;
  height: 50px !important;
}

.el-backtop__inner {
  width: 50px !important;
  height: 50px !important;
  background: transparent !important;
  padding: 0 !important;
} 

.back-top-btn {
  width: 50px;
  height: 50px;
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.4);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  cursor: pointer;
  z-index: 9999;
}

.back-top-btn:hover {
  transform: scale(1.15);
  box-shadow: 0 0 12px rgba(255, 180, 180, 0.3);
}

.top-icon {
  font-size: 24px;
  color: #fff;
}

.el-pagination__total {
  color: var(--font-color-4) !important;
}

/* 当按钮处于"已折叠"状态时，图标旋转90度 */
.toggle-icon.is-collapsed {
  transform: rotate(180deg); /* ← 这行是实际的旋转动作 */
}

.auto-textarea-wrapper-input,
.content-input,
.v-note-wrapper,
.content-input-wrapper,
.auto-textarea-input,
.v-show-content,
.v-note-op,
.sub-input input {
  background-color: rgba(255, 255, 255, 0) !important;
}

.v-note-wrapper * {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  background: transparent !important;
}

.info .v-note-wrapper {
  z-index: auto !important;
  position: static !important;
}

:root {
  --font-color-1: #2c2416;
  --font-color-2: #c46b3f;
  --font-color-3: #5f7f6b;
  --font-color-4: #2A1F23;
  --font-color-5: #FFFFFF;
  --font-color-6: #f8efe0;
}

.font-color-1 {
  color: #080808;
  color: var(--font-color-1);
}

.font-color-2 {
  color: #c46b3f;
  color: var(--font-color-2);
}

.font-color-3 {
  color: #5f7f6b;
  color: var(--font-color-3);
}

.font-color-4 {
  color: #2A1F23;
  color: var(--font-color-4);
}

.font-color-5 {
  color: #FFFFFF;
  color: var(--font-color-5);
}

.font-color-6 {
  color: #ffe8d0;
  color: var(--font-color-6);
}

.root-box-shadow {
  box-shadow:
    7px 7px 10px rgba(0, 0, 0, .9),
    -5px -5px 10px rgba(239, 235, 235, 0.3);
}


.mbl {
  background-color: rgba(255, 250, 240, 0.7);
  backdrop-filter: blur(16px) saturate(180%);
  -webkit-backdrop-filter: blur(16px) saturate(180%);
  border: 1px solid rgba(200, 180, 140, 0.5);
  box-shadow:
    7px 7px 10px rgba(0, 0, 0, .9),
    -5px -5px 10px rgba(239, 235, 235, 0.3);
  transition: all 0.5s cubic-bezier(0.22, 0.61, 0.36, 1);
}

.mbl-no-hover {
  background-color: rgba(255, 250, 240, 0.7);
  backdrop-filter: blur(16px) saturate(180%);
  -webkit-backdrop-filter: blur(16px) saturate(180%);
  border: 1px solid rgba(200, 180, 140, 0.5);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.5s cubic-bezier(0.22, 0.61, 0.36, 1);
}

.mbl:hover,
.mbl:active {
  transform: translateY(-8px) scale(1.02);
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.08), 0 10px 10px rgba(0, 0, 0, 0.06);
}

html::-webkit-scrollbar,
body::-webkit-scrollbar {
  width: 0;
  height: 0;
  display: none;
}
html, body {
  scrollbar-width: none;
  -ms-overflow-style: none;
}

/* 如果还保留 tooltip 样式但不再使用，可以保留或删除 */
.el-tooltip__popper {
  background: rgba(255, 255, 255, 0.15) !important;
  backdrop-filter: blur(20px) saturate(180%) !important;
  -webkit-backdrop-filter: blur(20px) saturate(180%) !important;
  border: 1px solid rgba(255, 255, 255, 0.25) !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2) !important;
  color: #fff !important;
  font-family: 'LXGW WenKai', sans-serif !important;
  font-size: 13px !important;
  padding: 6px 14px !important;
  border-radius: 8px !important;
  letter-spacing: 0.5px !important;
}

.el-tooltip__popper[x-placement^="left"] .popper__arrow,
.el-tooltip__popper[x-placement^="right"] .popper__arrow,
.el-tooltip__popper[x-placement^="top"] .popper__arrow,
.el-tooltip__popper[x-placement^="bottom"] .popper__arrow {
  border-color: transparent !important;
}

.el-tooltip__popper[x-placement^="left"] .popper__arrow::after {
  border-left-color: rgba(255, 255, 255, 0.15) !important;
}
.el-tooltip__popper[x-placement^="right"] .popper__arrow::after {
  border-right-color: rgba(255, 255, 255, 0.15) !important;
}
.el-tooltip__popper[x-placement^="top"] .popper__arrow::after {
  border-top-color: rgba(255, 255, 255, 0.15) !important;
}
.el-tooltip__popper[x-placement^="bottom"] .popper__arrow::after {
  border-bottom-color: rgba(255, 255, 255, 0.15) !important;
}
</style>